let en = {
    "translation" : {
        "has already been taken" : "Registration failed.",
        "can't be blank" : "can't be blank"
    }
};

export default en;
